import { render, staticRenderFns } from "./ProjectCopyPopup.vue?vue&type=template&id=f553245e"
import script from "./ProjectCopyPopup.vue?vue&type=script&lang=ts"
export * from "./ProjectCopyPopup.vue?vue&type=script&lang=ts"
import style0 from "./ProjectCopyPopup.vue?vue&type=style&index=0&id=f553245e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports